import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { Container } from '../../Layout/LayoutStyled';
import { FrontierLogo } from '../../Icons/outline';
import { NextGenHeaderStyled } from './NextGenHeaderStyled';
import EditAddress from '~/components/EditAddress';
import ClaimRewardsToggle from '~/components/ClaimRewardsToggle';
import { ClaimRewardsToggleStyled } from '~/components/ClaimRewardsToggle/ClaimRewardsToggleStyled';
import { ReduxState } from '~/types/redux';
import { getSite } from '~/helpers/site';
import { useClaimRewards } from '~/hooks/useClaimRewards';
import { PAGE_ROUTES } from '~/constants/pages';
import useMediaQuery from '~/hooks/useMediaQuery';
import VerizonFrontierLogo from '~/components/Icons/outline/VerizonFrontierLogo';

const ClaimRewardsToggleExtended = styled(ClaimRewardsToggleStyled)`
  gap: 12px;
`;

const NextGenHeader: React.FC = () => {
  const [baseUrl, setBaseUrl] = useState('/');
  const {
    tracking,
    monarch: { verizonView },
  } = useSelector((store: ReduxState) => store);
  const [quoteString, setQuoteString] = useState('');
  const { isFRIN } = getSite();
  const { claimRewardsLocation } = useClaimRewards();
  const router = useRouter();
  const isBuildPage = router.route === PAGE_ROUTES.BUILD;

  const isMobile = useMediaQuery('(max-width: 767px)');
  const [showVerizonFrontierLogo, setShowVerizonFrontierLogo] = useState(false);
  
  useEffect(() => {
    setShowVerizonFrontierLogo(verizonView && !isMobile);
  }, [verizonView, isMobile]);

  useEffect(() => {
    /*
     * FRIN's homepage is /ps/
     * INFR and FRDC's homepage is /
     */
    if (isFRIN) {
      setBaseUrl('/ps/');
    }
  }, []);

  useEffect(() => {
    setQuoteString(`Quote Number ${tracking?.quoteNumber}`);
  }, [tracking?.quoteNumber]);

  return (
    <NextGenHeaderStyled>
      <Container>
        <div className="header__left-content">
          <a href={baseUrl} aria-label="Home">
            {showVerizonFrontierLogo ? (
              <VerizonFrontierLogo aria-label="Frontier Logo" />
            ) : (
              <FrontierLogo width="36" height="36" aria-label="Frontier Logo" />
            )}
          </a>
          <div className="edit-address--desktop">
            <EditAddress showWarningModal={true} isAiFlow={true} />
          </div>
        </div>
        <div className="header__right-content">
          {claimRewardsLocation === 'header' && !isBuildPage && <ClaimRewardsToggle as={ClaimRewardsToggleExtended} />}

          <div className="edit-address--mobile">
            <EditAddress showWarningModal={true} isAiFlow={true} />
          </div>
          {tracking?.quoteNumber && <p className="quoteNumber">{quoteString}</p>}
        </div>
      </Container>
    </NextGenHeaderStyled>
  );
};

NextGenHeader.displayName = 'Header';
export default NextGenHeader;
